import { type FC } from "react";
import { useIntl } from "react-intl";
import { ConfirmationModal } from "@packsize/components";

import { type MachineGroup } from "@/schemas/machine-group";

export interface RemoveMachineGroupFromProductionGroupModalProps {
	readonly open: boolean;
	readonly machineGroup: MachineGroup | null;
	readonly onConfirm: (mg: MachineGroup) => void;
	readonly onCancel: () => void;
}

/**
 * Shared modal for confirming removal of a machine group from its production group.
 * Used in LocationControl component.
 *
 * This action can negatively impact production workflow, so it requires explicit confirmation.
 */
export const RemoveMachineGroupFromProductionGroupModal: FC<RemoveMachineGroupFromProductionGroupModalProps> = ({
	open,
	machineGroup,
	onConfirm,
	onCancel,
}) => {
	const intl = useIntl();

	const handleClose = async (response: boolean) => {
		if (response && machineGroup) {
			onConfirm(machineGroup);
		}
		onCancel();
	};

	return (
		<ConfirmationModal
			open={open}
			onClose={() => {
				handleClose(false);
			}}
			onCancel={() => {
				handleClose(false);
			}}
			onConfirm={() => {
				handleClose(true);
			}}
			title={intl.formatMessage({
				id: "Remove Machine Group from Production Group",
				defaultMessage: "Remove Machine Group from Production Group",
			})}
			confirmText={intl.formatMessage({ id: "Yes", defaultMessage: "Yes" })}
			cancelText={intl.formatMessage({ id: "Cancel", defaultMessage: "Cancel" })}
			size="lg"
		>
			{intl.formatMessage({
				id: "Would you like to remove this machine group from the current production group This can negatively impact the way jobs are produced",
				defaultMessage:
					"Would you like to remove this machine group from the current production group? This can negatively impact the way jobs are produced.",
			})}
		</ConfirmationModal>
	);
};
